import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '../../_services/common.service';
import { environment } from '../../../environments/environment';
import { Router, NavigationExtras } from '@angular/router';
import { NavController } from '@ionic/angular';
import { of, Subscription } from 'rxjs';
import { catchError, finalize, map, take, tap } from 'rxjs/operators';
import { LoginConfigService } from '../../_services/login-config.service';
import { SEOConfigurationService } from '../../_services/seo-configuration.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
	@Input() showOnlyLowFooter?: boolean = false;
	customerUrl: any;
	currentYear = new Date().getFullYear();
	private subscription = new Subscription();

	// Footer logo, fetched from the backend at runtime same as customer-website;
	// falls back to the static asset while loading or on error.
	isLogoLoading = true;
	logoUrl = './assets/icon/companyLogo-revest.svg';

	constructor(
		public commonService: CommonService,
		private router: Router,
		private navCtrl: NavController,
		private loginConfigService: LoginConfigService,
		public seoConfiguration: SEOConfigurationService,
	) { }

	ngOnInit() {
		this.customerUrl = environment.customerUrl;
		this.loadFooterLogo();
	}

	private loadFooterLogo(): void {
		this.subscription.add(
			this.loginConfigService.getFooterConfig().pipe(
				map((res) => res?.data?.[0]?.image_url ?? null),
				tap((logo) => {
					if (logo) this.logoUrl = logo;
				}),
				catchError(() => of(null)),
				finalize(() => this.isLogoLoading = false),
				take(1),
			).subscribe(),
		);
	}

	// Go to relevant page
	navigate(page) {
		this.router.navigate(['/account-details/' + page]);
	}

}
